var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollaboration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2701 9.54749C14.9926 9.54749 14.7601 9.33749 14.7301 9.05999C14.5501 7.40999 13.6651 5.92499 12.3001 4.97999C12.0526 4.80749 11.9926 4.46999 12.1651 4.22249C12.3376 3.97499 12.6751 3.91499 12.9226 4.08749C14.5501 5.21999 15.6001 6.98999 15.8176 8.94749C15.8476 9.24749 15.6301 9.51749 15.3301 9.54749C15.3076 9.54749 15.2926 9.54749 15.2701 9.54749Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80497 9.58503C2.78997 9.58503 2.76747 9.58503 2.75247 9.58503C2.45247 9.55503 2.23497 9.28503 2.26497 8.98503C2.46747 7.02753 3.50247 5.25753 5.11497 4.11753C5.35497 3.94503 5.69997 4.00503 5.87247 4.24503C6.04497 4.49253 5.98497 4.83003 5.74497 5.00253C4.39497 5.96253 3.51747 7.44753 3.35247 9.09003C3.32247 9.37503 3.08247 9.58503 2.80497 9.58503Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9925 15.825C11.07 16.2675 10.08 16.4925 9.04495 16.4925C7.96495 16.4925 6.93745 16.2525 5.97745 15.765C5.70745 15.6375 5.60245 15.3075 5.73745 15.0375C5.86495 14.7675 6.19495 14.6625 6.46495 14.79C6.93745 15.03 7.43995 15.195 7.94995 15.2925C8.63995 15.4275 9.34495 15.435 10.035 15.315C10.545 15.225 11.0475 15.0675 11.5125 14.8425C11.79 14.715 12.12 14.82 12.24 15.0975C12.375 15.3675 12.27 15.6975 11.9925 15.825Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03761 1.50751C7.87511 1.50751 6.92261 2.45251 6.92261 3.62251C6.92261 4.79251 7.86761 5.73751 9.03761 5.73751C10.2076 5.73751 11.1526 4.79251 11.1526 3.62251C11.1526 2.45251 10.2076 1.50751 9.03761 1.50751Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78761 10.4025C2.62511 10.4025 1.67261 11.3475 1.67261 12.5175C1.67261 13.6875 2.61761 14.6325 3.78761 14.6325C4.95761 14.6325 5.90261 13.6875 5.90261 12.5175C5.90261 11.3475 4.95011 10.4025 3.78761 10.4025Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2124 10.4025C13.0499 10.4025 12.0974 11.3475 12.0974 12.5175C12.0974 13.6875 13.0424 14.6325 14.2124 14.6325C15.3824 14.6325 16.3274 13.6875 16.3274 12.5175C16.3274 11.3475 15.3824 10.4025 14.2124 10.4025Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaboration);
export default __webpack_public_path__ + "97120/static/media/Collaboration.978de0b1ba93fa6f75278c9489d24eaf.svg";
export { ForwardRef as ReactComponent };